import React from 'react';
import PropTypes from 'prop-types';
import moment from "moment";
import CustomButtonForDatePicker from './CustomButtonForDatePicker';
import DatePicker from 'react-datepicker';

import 'react-datepicker/dist/react-datepicker.min.css';

// To see all possible properties of the react-datepicker:
// https://reactdatepicker.com

const propTypes = {
	// A function that returns an icon, usually an svg icon to show. Can be any element, however
	icon: PropTypes.func,

	// Function that fires when the date changes
	onChange: PropTypes.func.isRequired,

	// The selected date, moment or date object
	selected: PropTypes.object,

	// If you don't provide an icon you can prevent display of the default icon.
	showDefaultIcon: PropTypes.bool,

	// Show the "Choose" text on the calendar picker button
	showText: PropTypes.bool.isRequired,
};

const defaultProps = {
	icon: undefined,
	selected: undefined,
	showDefaultIcon: true,
};

export default class DatePickerButton extends React.Component {
	render() {
		const {
			icon,
			onChange,
			selected,
			showDefaultIcon,
			showText,
			...passThroughProps
		} = this.props;

		const dateSelected = moment.isMoment(selected) ? selected.toDate() : selected;

		return (
			<DatePicker
				customInput={<CustomButtonForDatePicker showText={showText} icon={icon} showDefaultIcon={showDefaultIcon} />}
				onChange={onChange}
				selected={dateSelected}
				{...passThroughProps}
			/>
		);
	}
}

DatePickerButton.propTypes = propTypes;
DatePickerButton.defaultProps = defaultProps;